const initialState = {
  cards: [],
  hasError: false,
  validatePin: {},
  // Response from travel exemption eligibility endpoint
  travelExemptionEligibility: {},
  // Response from travel exemption submission endpoint
  travelExemptionResponse: {},
  // Country options response for travel exemptions
  countryOptions: [],
  // Card owners response for travel exemptions
  cardOwners: [],
  existingTravels: [],
  existingTravelsLoaded : false,
  cardsLoaded : false
};

export function cardControls(state = initialState, action) {
  switch (action.type) {
    case "BEGIN_CARD_CONTROLS_SESSION":
      return state;

    case "CARD_CONTROLS_SET_CARD_LIST":
      return {
        ...state,
        cards: action.cardListResponse,
        cardsLoaded: true,
      };

    case "CARD_CONTROLS_SET_PIN_VALIDATION":
      return {
        ...state,
        validatePin: action.validatePin,
      };

    case "CARD_CONTROLS_SAVE_CARD_STATUS":
      return state;

    case "CARD_CONTROLS_SET_MAILING_ADDRESS":
      return {
        ...state,
        mailingAddress: action.mailingAddress
      };

    case "CARD_CONTROLS_SET_BRANCHES":
      return {
        ...state,
        branches: action.branches
      };

    case "RESET_CARD_CONTROLS":
      return initialState;

    // Cases for travel exemptions
    case "SET_TRAVEL_EXEMPTION_ELIGIBILITY":
      return { ...state, travelExemptionEligibility: action.travelExemptionEligibility };
    case "SET_COUNTRY_OPTIONS":
      return { ...state, countryOptions: action.countryOptions };
    case "SET_CARD_OWNERS":
      return { ...state, cardOwners: action.cardOwners };
      case "SET_EXISTING_TRAVELS":
        return { ...state, existingTravels: action.existingTravels, existingTravelsLoaded: true };
    // Case for saving travel exemption submission response
    case "SET_EXEMPTION_RESPONSE":
      return { ...state, travelExemptionResponse: action.travelExemptionResponse };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/cardControls.js